/**
 * 크레딧 API
 * - 본인 잔액 조회
 * - 관리자 전용 크레딧 충전
 *
 * 백엔드 엔드포인트:
 *   GET  /api/credits/balance  — 본인 크레딧 잔액 (JWT 필수)
 *   POST /api/credits/refill   — 관리자 전용 충전
 */
import apiClient from './client';

/** 트랜잭션 사유 유니온 — 백엔드 CreditReason 과 1:1 대응. */
export type CreditReason =
  | 'ai.suggest.text'
  | 'ai.suggest.image'
  | 'refill.monthly'
  | 'refill.admin'
  | 'refill.purchase'
  | 'refund.error';

/** GET /api/credits/balance 응답 */
export interface CreditBalanceResponse {
  balance: number;
}

/** POST /api/credits/refill 요청 본문 */
export interface RefillCreditsRequest {
  userId: string;
  /** 충전 크레딧 수량 (1 ~ 10,000) */
  amount: number;
  /** 충전 사유 (미입력 시 서버가 'refill.admin' 사용) */
  reason?: Extract<CreditReason, 'refill.monthly' | 'refill.admin' | 'refund.error'>;
}

/** POST /api/credits/refill 응답 */
export interface RefillCreditsResponse {
  balance: number;
}

export const creditsApi = {
  /** 본인 크레딧 잔액 조회 (JWT 필수). */
  getBalance: () =>
    apiClient.get<CreditBalanceResponse>('/credits/balance'),

  /**
   * 관리자 전용 크레딧 충전.
   * RolesGuard('admin') 으로 보호됨.
   */
  refill: (body: RefillCreditsRequest) =>
    apiClient.post<RefillCreditsResponse>('/credits/refill', body),
};
